import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

class SelectBox extends Component {
  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange({ value }) {
    const { onChange } = this.props.input;
    onChange && onChange(value);
  }

  onBlur() {
    const { onBlur, value } = this.props.input;
    onBlur && onBlur(value);
  }

  render() {
    const { input, label, placeholder, options, meta: { touched, error } } = this.props;

    return (
      <div className={`form-group ${(touched && error) ? 'has-error' : ''}`}>
        {label && <label className="input-label" htmlFor={input.name}>{label}</label>}
        <div className="field">
          <Select
            name={input.name}
            value={input.value || ''}
            options={options}
            placeholder={placeholder || false}
            onBlur={this.onBlur}
            onChange={this.onChange}
            clearable={false}
            searchable={false}
            noResultsText="No hay opciones"
          />
          {touched && error && <span className="error-message">{error}</span>}
        </div>
      </div>
    );
  }
}

const { string, object, array } = PropTypes;

SelectBox.propTypes = {
  input: object.isRequired,
  label: string,
  placeholder: string,
  options: array,
  meta: object
};

export default SelectBox;



// WEBPACK FOOTER //
// ./src/components/common/SelectBox.js